import React from 'react';
import { Smartphone, Tablet, Cable, MoreHorizontal } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const products = [
  {
    icon: Smartphone,
    title: 'Phones',
    description: 'Latest smartphones and certified pre-owned devices'
  },
  {
    icon: Tablet,
    title: 'Electronics',
    description: 'Tablets, smartwatches, and gaming consoles'
  },
  {
    icon: Cable,
    title: 'Accessories',
    description: 'Cases, screen protectors, chargers, and more'
  },
  {
    icon: MoreHorizontal,
    title: 'More',
    description: 'Cables, adapters, and tech essentials'
  }
];

const ProductsSection = () => {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-6">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Products We Sell
          </h2>
          <div className="w-24 h-1 mx-auto mb-6" style={{ backgroundColor: '#00B3B3' }} />
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Quality devices and accessories for all your tech needs
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12">
          {products.map((product, index) => (
            <Card 
              key={index} 
              className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <CardContent className="p-8 text-center">
                <div 
                  className="inline-flex items-center justify-center w-20 h-20 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300"
                  style={{ backgroundColor: '#00B3B3' }}
                >
                  <product.icon className="w-10 h-10 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {product.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {product.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
